import gql from "graphql-tag"

export const VALIDATE_ZAVER = gql`
  query validateZaver($apiKey: String!, $baseUrl: String!) {
    Configuration {
      validate {
        zaver(apiKey: $apiKey, baseUrl: $baseUrl) {
          errorMessage
          valid
        }
      }
    }
  }
`
